export const THUMBS_DOWN = '../../assetes/thumb-down.svg';
export const THUMBS_UP = '../../assetes/thumb-up.svg';
export const THUMBS_DOWN_OUTLINE = '../../assetes/thumb-down-outline.svg';
export const THUMBS_UP_OUTLINE = '../../assetes/thumb-up-outline.svg';
